import { render, staticRenderFns } from "./CardBarChart.vue?vue&type=template&id=82544560&scoped=true"
import script from "./CardBarChart.vue?vue&type=script&lang=js"
export * from "./CardBarChart.vue?vue&type=script&lang=js"
import style0 from "./CardBarChart.vue?vue&type=style&index=0&id=82544560&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82544560",
  null
  
)

export default component.exports